/**
 * Loopt de te vertalen waarden af in een vaste volgorde.
 * Zowel het verzamelen als het terugzetten gebruikt deze volgorde, zodat de
 * vertalingen exact op hun oorspronkelijke plek terugkomen.
 *
 * @param {any} value - String, object met strings, of iets anders (blijft ongemoeid)
 * @param {(text: string) => any} visit - Krijgt elke string; de returnwaarde komt op die plek
 * @returns {any} Dezelfde vorm, met de returnwaarden van `visit` op de stringplekken
 */
const walk = (value, visit) => {
    if (typeof value === 'string') return visit(value);

    if (value && typeof value === 'object') {
        const out = {};
        Object.entries(value).forEach(([key, nested]) => { out[key] = walk(nested, visit); });
        return out;
    }

    return value;
};

/**
 * Verzamelt alle te vertalen strings uit de set die de vragenlijst opbouwt.
 *
 * @param {Record<string, any>} strings - Te vertalen set, waarden zijn strings of objecten
 * @returns {string[]} Alle strings, plat en op vaste volgorde
 */
const collectTranslatableTexts = (strings) => {
    const texts = [];
    walk(strings || {}, (text) => { texts.push(text); return text; });
    return texts;
};

/**
 * Zet vertaalde strings terug in de oorspronkelijke vorm.
 *
 * @param {Record<string, any>} strings - De originele set
 * @param {string[]} translations - Vertalingen in de volgorde van collectTranslatableTexts
 * @returns {Record<string, any>} Dezelfde vorm, met vertaalde waarden
 */
const applyTranslations = (strings, translations) => {
    let cursor = 0;
    return walk(strings || {}, () => translations[cursor++]);
};

export { collectTranslatableTexts, applyTranslations };
